import type { FC } from "react";

import { type ClipboardStatus, useClipboard } from "../../hooks/useClipboard";
import { Button } from "./Button";

function copyButtonLabel(status: ClipboardStatus): string {
  switch (status) {
    case "copied": {
      return "Copied!";
    }
    case "failed": {
      return "Failed";
    }
    case "idle": {
      return "Copy";
    }
  }
}

interface CopyButtonProps {
  /** The text to copy to the clipboard. */
  text: string;
}

/**
 * Small copy-to-clipboard button with transient "Copied!" / "Failed" feedback.
 *
 * Manages its own clipboard state internally so consumers only need to pass
 * the text value.
 */
export const CopyButton: FC<CopyButtonProps> = ({ text }) => {
  const { status, copy } = useClipboard();

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => void copy(text)}
      className="border border-slate-300 bg-slate-100 text-emerald-700 hover:border-emerald-500 hover:bg-emerald-50 dark:border-slate-700 dark:bg-slate-900 dark:text-emerald-300 dark:hover:bg-emerald-500/10"
      title="Copy to clipboard"
    >
      {copyButtonLabel(status)}
    </Button>
  );
};
